import React from 'react'
import CommingSoon from '../../CommingSoon/CommingSoon'
// import ProjectTemplate from '../ProjectTemplate/ProjectTemplate'
export default function CSS(props) {
  return (
    <>
      {/* <ProjectTemplate name='CSS'/> */}
      <CommingSoon/>
    </>
  )
}
